(function () {
  Flint.file('mframework/views/link.js', function (require) {
    Flint.staticStyles('Link', {
      '$': '#_flintapp .ViewLink'
    }, {
      '$': {
        textDecoration: 'none',
        display: 'flex'
      }
    });
    Flint.viewRoots["Link"] = 'a';
    Flint.view('Link', function (view, on, $) {
      var pro = initPro(view, {
        to: atom(),
        target: atom(),
        children: atom(),
        track: M.defaultAtom(true)
      });

      var go = function go(e) {
        if (e.button == 0 && !e.metaKey) {
          var oldPreventDefault = e.preventDefault.bind(e);

          var defaultPrevented = false;
          e.preventDefault = function () {
            defaultPrevented = true;
          };

          if (view.props.onClick) view.props.onClick(e);

          e.preventDefault = oldPreventDefault;

          if (defaultPrevented) {
            oldPreventDefault();
          } else {
            if (pro.track.get()) {
              M.mixpanel.track("LinkClick", {
                to: pro.to.get(),
                linkId: pro.track.get() === true ? null : pro.track.get()
              });
            }

            if (pro.target.get() != '_blank' &&
            // Flint.router.go can't handle redirecting to another site
            pro.to.get().indexOf('://') == -1) {
              oldPreventDefault();
              Flint.router.go(pro.to.get());
              document.body.scrollTop = 0;
            }
          }
        }
      };

      var hovering = atom(false);
      hovering.react(function (hovering) {
        if (view.props.onHover) {
          view.props.onHover({ hovering: hovering });
        }
      }, { skipFirst: true });view.render(function () {
        return view.el(
          ['a', 1],
          { root: true,
            href: pro.to.get(),
            target: pro.target.get(),
            onClick: go,
            onMouseEnter: function () {
              return hovering.set(true);
            },
            onMouseLeave: function () {
              return hovering.set(false);
            }
          },
          pro.children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=link.js.map
